import React from 'react';
import { useParams } from 'react-router-dom';
import AppShowcase from './AppShowcase';
import AppPromotion from './AppPromotion';
import FooterLinks from './FooterLinks';

interface UnifiedFooterProps {
  variant?: 'showcase' | 'promotion' | 'minimal' | 'personal';
  lang?: 'en' | 'fr' | 'de' | 'it';
}

const UnifiedFooter: React.FC<UnifiedFooterProps> = ({ 
  variant = 'minimal', 
  lang: propLang 
}) => {
  const { lang: paramLang } = useParams<{ lang?: string }>();
  const currentLang = (propLang || paramLang || 'en') as 'en' | 'fr' | 'de' | 'it';

  const renderMinimalFooter = () => (
    <footer className="mt-auto py-8 border-t border-gray-100 dark:border-gray-800 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4">
        <FooterLinks lang={currentLang} />
      </div>
    </footer>
  );

  const renderPersonalFooter = () => (
    <footer className="mt-auto py-12 border-t border-gray-100 dark:border-gray-800 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4">
        <FooterLinks lang={currentLang} />
      </div>
    </footer>
  );

  switch (variant) {
    case 'showcase':
      return <AppShowcase />;
    case 'promotion':
      return <AppPromotion compact={false} lang={currentLang} />;
    case 'minimal':
      return renderMinimalFooter();
    case 'personal':
      return renderPersonalFooter();
    default:
      return renderMinimalFooter();
  }
};

export default UnifiedFooter;